// Word Chain page entry; on a daily page, swaps in the puzzle for the player's local date when needed.
import { WordChainGame } from "../word-chain/ui"
import { fetchDaily, mountCalendar, pageDate, updateLabel } from "../lib/daily"
import type { Puzzle } from "../word-chain/core"

async function start(): Promise<void> {
  const root = document.getElementById("board")
  if (!root) return
  const game = root.dataset.dailyGame
  if (game) {
    const { date } = pageDate(root)
    updateLabel(date)
    if (date !== root.dataset.dailyDate) {
      const daily = await fetchDaily<{ puzzle: Puzzle }>(game, date)
      if (daily) root.dataset.puzzle = JSON.stringify(daily.puzzle)
    }
    ;(window as unknown as { dtGame?: WordChainGame }).dtGame = new WordChainGame(root, { game, date })
    mountCalendar(game, "/word-chain")
    return
  }
  ;(window as unknown as { dtGame?: WordChainGame }).dtGame = new WordChainGame(root)
}

void start()
